"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _label = _interopRequireDefault(require("@ingka/label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nouislider = _interopRequireDefault(require("nouislider"));

var _sliderExtensions = require("./utils/slider-extensions");

var _Tooltips = _interopRequireDefault(require("./elements/Tooltips"));

var _SliderInputControls = _interopRequireDefault(require("./SliderInputControls"));

var _tools = require("./utils/tools");

var _formField = _interopRequireDefault(require("@ingka/form-field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Slider = _ref => {
  let {
    start,
    step,
    range,
    margin,
    prefix,
    ariaFormat,
    rtl,
    className,
    disabled,
    id,
    marks,
    maxMarks,
    prefixLabel,
    suffixLabel,
    inputControls,
    label,
    ariaLabels,
    format,
    behaviour,
    onUpdate,
    onChange,
    onSet,
    onStartDrag,
    onEndDrag,
    onValueChange,
    validators,
    ...props
  } = _ref;
  const ns = '.skapa';
  const values = (0, _tools.sanitizeValues)(start === undefined ? range.min : start, [range.min, range.max]);
  const [_values, setValues] = (0, _react.useState)(values);
  const isRangeSelector = Array.isArray(start) && start.length > 1;
  const slider = (0, _react.useRef)(null);
  const sliderDOM = (0, _react.useRef)(null);
  const [appliedRTL, setAppliedRTL] = (0, _react.useState)(rtl);
  const [isDragged, setDragged] = (0, _react.useState)(false);
  const updateStepMarkers = (0, _react.useRef)();
  const [validationMessages, setValidationMessages] = (0, _react.useState)([null, null]);
  const [currentErrorMessage, setCurrentErrorMessage] = (0, _react.useState)('');
  if (step <= 0 || step > range.max - range.min) console.error('Range field \'step\' value must be a non-zero positive number that is smaller than the given range!');

  if (range.max <= range.min) {
    console.error('Invalid range values');
    range.max = range.min + 1;
  }

  (0, _react.useEffect)(() => {
    values.forEach((value, index) => {
      const failedValidator = validators && validators.find(validator => !(validator.validate && validator.validate({
        value,
        index,
        values,
        range,
        step
      })));
      const newValidationMessages = validationMessages;
      newValidationMessages[index] = failedValidator && (typeof failedValidator.message === 'function' ? failedValidator.message({
        value,
        index,
        values,
        range,
        step
      }) : failedValidator.message);
      setValidationMessages(newValidationMessages);
    });
    setCurrentErrorMessage(validationMessages.find(err => err));
  }, [values]);

  const initializeSlider = () => {
    if (sliderDOM.current) {
      if (rtl === undefined) {
        rtl = (0, _tools.isRTL)();
        setAppliedRTL(rtl);
      }

      const pips = (0, _tools.createPips)(step, marks, disabled, range, maxMarks);
      slider.current = _nouislider.default.create(sliderDOM.current, {
        start: values,
        step,
        range,
        connect: isRangeSelector,
        behaviour,
        margin,
        direction: rtl ? 'rtl' : 'ltr',
        cssPrefix: `${prefix}slider-`,
        ariaFormat: ariaFormat,
        pips,
        tooltips: false
      });
      (0, _sliderExtensions.updateAriaLabels)(ariaLabels, sliderDOM, prefix);
      if (isRangeSelector && pips) updateStepMarkers.current = (0, _sliderExtensions.generateRangeOverlayMarks)(sliderDOM, slider, prefix);
    }
  };

  const bindSliderEvents = () => {
    const onSlide = newValues => {
      const numValues = newValues.map(Number);
      setValues(previousValues => !(0, _tools.isEqualContent)(numValues, previousValues) ? numValues : previousValues);
      if (onChange) onChange(numValues);
    };

    const handleValueChange = newValues => {
      if (onValueChange) onValueChange(newValues.map(Number));
    };

    const bindListener = (event, listener) => listener && slider.current.on(event, listener);

    if (slider.current) {
      bindListener('update' + ns, onUpdate);
      bindListener('slide' + ns, onSlide);
      bindListener('set' + ns, onSet);
      bindListener('start' + ns, (0, _tools.elx)(onStartDrag, () => setDragged(true)));
      bindListener('end' + ns, (0, _tools.elx)(onEndDrag, () => setDragged(false)));
      bindListener('change' + ns, handleValueChange);
    }
  };

  (0, _react.useEffect)(() => {
    initializeSlider();
    return () => {
      if (slider.current) slider.current.destroy();
    };
  }, [prefix]);
  (0, _react.useEffect)(() => {
    bindSliderEvents();
    return () => {
      if (slider.current) {
        slider.current.off(ns);
      }
    };
  }, [onUpdate, onChange, onSet, onStartDrag, onEndDrag, range.min, range.max]);
  (0, _react.useEffect)(() => {
    if (slider.current && slider.current.updateOptions) {
      const pips = (0, _tools.createPips)(step, marks, disabled, range, maxMarks);
      slider.current.updateOptions({
        margin,
        step,
        range,
        pips
      });
      updateStepMarkers.current = undefined;

      if (isRangeSelector && pips) {
        updateStepMarkers.current = (0, _sliderExtensions.generateRangeOverlayMarks)(sliderDOM, slider, prefix);
        updateStepMarkers.current(values, appliedRTL);
      }

      (0, _sliderExtensions.updateAriaLabels)(ariaLabels, sliderDOM, prefix);
    }
  }, [step, marks, range.min, range.max, disabled, ariaLabels]);
  (0, _react.useEffect)(() => {
    if (slider.current) {
      const currentStart = Array.isArray(slider.current.get('start')) ? slider.current.get('start') : [slider.current.get('start')];

      if (currentStart.length !== values.length) {
        slider.current.off(ns);
        slider.current.destroy();
        initializeSlider();
        bindSliderEvents();
      } else {
        const previousValues = (0, _tools.sanitizeValues)(slider.current.get(), [range.min, range.max]);
        if (updateStepMarkers.current) updateStepMarkers.current(values, appliedRTL);

        if (!(0, _tools.isEqualContent)(values, previousValues)) {
          if (!isDragged) slider.current.set(values, false);
        }
      }

      setValues(previousValues => !(0, _tools.isEqualContent)(values, previousValues) ? values : previousValues);
    }
  }, [start]);
  (0, _react.useEffect)(() => {
    setAppliedRTL(rtl === undefined ? (0, _tools.isRTL)() : rtl);
    if (slider.current) slider.current.updateOptions({
      rtl
    });
  }, [rtl]);
  const baseClass = `${prefix}slider`;
  const classes = (0, _classnames.default)(baseClass, values.length === 2 && `${baseClass}--dual-sliders`, inputControls && `${baseClass}--with-input`, disabled && `${baseClass}-disabled`, isDragged && `${baseClass}-drag`, className);

  const _inputControls = inputControls && (0, _react.cloneElement)(inputControls, {
    baseClass,
    baseId: id,
    range,
    prefix,
    disabled,
    step,
    prefixLabel,
    suffixLabel,
    format,
    validationMessages,
    values: _values,
    onInput: (0, _tools.elx)(inputControls.props.onInput, (ev, newValues) => {
      let sanitizedValue = (0, _tools.sanitizeValues)(newValues, [range.min, range.max]);
      setValues(previousValues => {
        slider.current.set(sanitizedValue, false);
        return !(0, _tools.isEqualContent)(newValues, previousValues) ? newValues : previousValues;
      });
      if (onChange) onChange(newValues);

      if (onValueChange) {
        const clamped = sanitizedValue.map(v => (0, _tools.clamp)(v, range.min, range.max));
        if ((0, _tools.isEqualContent)(clamped, newValues)) onValueChange(clamped);
      }
    })
  }) || undefined;

  const withInputLabels = !!(inputControls && inputControls.props.labels);
  return _react.default.createElement("div", _extends({}, props, {
    className: classes
  }), _react.default.createElement("div", {
    className: `${baseClass}__controls`
  }, _react.default.createElement(_label.default, {
    className: (0, _classnames.default)(`${baseClass}__label`, withInputLabels && isRangeSelector && `${baseClass}__label-dbm`),
    prefix: prefix,
    htmlFor: id,
    label: label
  }), _inputControls), _react.default.createElement(_formField.default, {
    prefix: prefix,
    id: `${baseClass}__slider-form-field`,
    className: `${baseClass}__form-field`,
    shouldValidate: !!currentErrorMessage,
    valid: !currentErrorMessage,
    validation: {
      id: `${baseClass}__slider-error-message`,
      msg: currentErrorMessage
    },
    withIcon: true
  }), _react.default.createElement("div", {
    disabled: disabled,
    className: `${baseClass}__element`,
    id: id,
    ref: sliderDOM
  }), !_inputControls && !disabled && _react.default.createElement(_Tooltips.default, {
    prefix: prefix,
    className: (0, _classnames.default)(`${baseClass}-tooltips`, isDragged && `${baseClass}-tooltips-drag`),
    values: _values,
    range: range,
    rtl: appliedRTL,
    format: val => `${appliedRTL ? suffixLabel : prefixLabel}${format.to(val)}${appliedRTL ? prefixLabel : suffixLabel}`
  }));
};

Slider.defaultProps = {
  prefix: '',
  step: 1,
  prefixLabel: '',
  suffixLabel: '',
  maxMarks: 100,
  format: {
    to: num => num.toString(),
    from: str => str.length === 0 || Number.isNaN(Number(str)) ? str : Number(str)
  }
};
var _default = Slider;
exports.default = _default;